import { MuiIcon } from "@cirrus/ui-kit/src/components/atoms/mui-icon/index.js"
import { Button } from "@cirrus/ui-kit/src/components/molecules/button/index.js"
import { Popover } from "@cirrus/ui-kit/src/components/organisms/popover/index.jsx"

// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { ClickAwayListener, styled } from "@mui/material"
import React, { ReactElement, useCallback, useEffect, useMemo, useState } from "react"
import { setLocalStorageValues, TableLocalStorageKey } from "../../helpers"
import { useTableContext } from "../../provider"

import { useFilterButtonStyles } from "./FilterButtonStyles"

const StyledButton = styled(Button)({
  "&[class*=MuiButton-outlined]": {
    paddingLeft: "8px",
    paddingRight: "42px",
    display: "flex",
    gap: "15px",
    "& .MuiButton-startIcon": {
      margin: 0
    },
    "&, &:hover": {
      border: "2px solid #EBEBEB"
    }
  }
})

const StyledPopover = styled(Popover)({
  border: "1px solid #F1F3F4"
})

export const FiltersButton = (): ReactElement => {

  const [anchor, setAnchor] = useState(null)
  const [filterCounter, setFilterCounter] = useState(0)

  const { counterContainer, filterButtonContainer, filterPopover } = useFilterButtonStyles()

  const ctx = useTableContext()

  const { filters, filtersPopover, defaultFilters } = ctx.props

  const onClick = (event) => {
    setAnchor(anchor
      ? null
      : event.currentTarget)
  }

  useEffect(() => {
    const { values } = ctx.filters.state
    const count = Object
      .keys(values || {})
      .filter((key: string) =>
        Array.isArray(values[key])
          ? values[key].length > 0
          : values[key]
      )
      .length

    setFilterCounter(count)
  }, [ctx.filters.state.values])

  const onChange = useCallback((values) => {
    ctx.selection.api.reset()
    ctx.filters.api.setValues({...defaultFilters || {}, ...values || {}})
    setLocalStorageValues(ctx.props.tableId, TableLocalStorageKey.filters, values)
  }, [anchor])

  const onReset = () => {
    if (Object.keys(ctx.filters.state.values).length === 0) {
      return
    }

    ctx.selection.api.reset()
    setLocalStorageValues(ctx.props.tableId, TableLocalStorageKey.filters, {})
    ctx.filters.api.setValues(defaultFilters || {})
  }

  if (!filters) return <></>

  return (
    <ClickAwayListener onClickAway={() => setAnchor(null)}>
      <>
        <div className={filterCounter > 0 ? filterButtonContainer : ""}>
          <StyledButton
            height={44}
            label={i18n("General.Filter:Filter")}
            variant="outlined"
            onClick={onClick}
            hoverStyle="never"
            disableRipple
            startIcon={<MuiIcon.FilterList />}
          />
          {!!filterCounter && <div className={counterContainer}>{filterCounter}</div>}
        </div>
        {anchor && <StyledPopover
          className={filterPopover}
          anchor={anchor}
          content={filters({onChange, onReset})}
          onClose={() => setAnchor(null)}
          open={true}
          title={i18n("General.Filter:Filter")}
          anchorOrigin={filtersPopover?.anchorOrigin}
          transformOrigin={filtersPopover?.transformOrigin}
        />}
      </>
    </ClickAwayListener>
  )
}
